import styled from 'styled-components'

export const StyledStatsList = styled.div`
	margin-top: 0px !important;
	width: 674px;
	display: flex;
	justify-content: space-between;
	float: right;
	margin-top: 20px;
	@media (max-width: 1200px){
		width: 278px;
		display: grid;
		grid-template-columns: 143px 1fr;
		justify-content: end;
		gap: 10px;
	}
	@media (max-width: 768px){
		width: 270px;
		grid-template-columns: 130px 130px;
	}
	@media (max-width: 625px){
		width: 100%;
		grid-template-columns: 1fr 1fr;
	}
`
